import { render, staticRenderFns } from "./CadastroImplemento.vue?vue&type=template&id=244ce1d8"
import script from "./CadastroImplemento.vue?vue&type=script&lang=js"
export * from "./CadastroImplemento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports